import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useCallback } from "react";
const STORAGE_KEY = "avh-demo-user";
const DemoContext = createContext({
    demoUser: null,
    setDemoUser: () => { },
    clear: () => { },
});
function readStored() {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw)
            return null;
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed.email === "string" && typeof parsed.name === "string" && typeof parsed.role === "string") {
            return parsed;
        }
        return null;
    }
    catch {
        return null;
    }
}
export const DemoProvider = ({ children }) => {
    const [demoUser, setDemoUserState] = useState(() => readStored());
    const setDemoUser = useCallback((user) => {
        setDemoUserState(user);
        try {
            if (user)
                sessionStorage.setItem(STORAGE_KEY, JSON.stringify(user));
            else
                sessionStorage.removeItem(STORAGE_KEY);
        }
        catch { /* ignore */ }
    }, []);
    const clear = useCallback(() => setDemoUser(null), [setDemoUser]);
    return (_jsx(DemoContext.Provider, { value: { demoUser, setDemoUser, clear }, children: children }));
};
export const useDemo = () => useContext(DemoContext);
